import { FC } from "react";

import IRHMADesktop from "../../../../assets/images/content/introduction/irhma/irhma-desktop.png";
import IRHMAMobile from "../../../../assets/images/content/introduction/irhma/irhma-mobile.png";

const IRHMA: FC = () => (
	<div className="-mx-6 md:-mx-9 xl:-mx-14 -mt-8 md:-mt-12">
		<img src={IRHMADesktop} className="hidden md:block" role="presentation" />
		<img src={IRHMAMobile} className="block md:hidden" role="presentation" />
	</div>
);

export { IRHMA };